import styled from 'styled-components';

export const PageContainer = styled.div<{ $bg?: string }>`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
  background: ${({ $bg }) => ($bg ? $bg : '#fff')};
`;
